import _ from 'lodash';
import axios from 'axios';
import { getValueOrDefault, hasValue } from '../assets/scripts/helpers';
import { ERROR_MESSAGES } from '../assets/constants/errorConstants';
import { APIS, API_TYPES, BASE_URLS } from '../assets/constants/apiConstants';

export async function postData({
  options,
  key,
  params,
  endpoint,
  apiType,
  method,
  body,
}) {
  if (!_.isEmpty(options.promises)) {
    const promise = options.promises.find(
      (p) => p.key === key && p.params === params && p.endpoint === endpoint
    );
    if (hasValue(promise)) {
      return promise.promise;
    }
  }
  const promise = getBaseData(
    options,
    APIS[key],
    params,
    endpoint,
    apiType,
    'post',
    body
  );
  options.promises = options.promises ? options.promises : [];
  options.promises.push({ key, promise, params, endpoint });
  return promise;
}

export async function getData(
  options,
  key,
  params,
  endpoint,
  apiType,
  method,
  body
) {
  /// #endif
  if (!_.isEmpty(options.promises)) {
    const promise = options.promises.find(
      (p) => p.key === key && p.params === params && p.endpoint === endpoint
    );
    if (hasValue(promise)) {
      return promise.promise;
    }
  }
  const promise = getBaseData(
    options,
    APIS[key],
    params,
    endpoint,
    apiType,
    method,
    body
  );
  options.promises = options.promises ? options.promises : [];
  options.promises.push({ key, promise, params, endpoint });
  return promise;
}

async function getBaseData(
  options,
  root,
  params,
  endpoint,
  apiType,
  method = 'get',
  body = {}
) {
  try {
    let url = root;
    // -----
    // URL Additions
    // -----
    if (hasValue(endpoint)) url += `/${endpoint}`;
    if (hasValue(params))
      url += `?${Object.keys(params)
        .map((key) => key + '=' + params[key])
        .join('&')}`;
    // -----
    if (method === 'get') {
      return await sendGetRequest(url, apiType);
    } else if (method === 'post') {
      return await sendPostRequest(url, body, apiType);
    }
  } catch (err) {
    console.log('service error: ', err);
    const error = getValueOrDefault(err, 'response.status', null);
    if (error === 404) {
      throw new Error(ERROR_MESSAGES.NO_DATA);
    } else {
      throw new Error(ERROR_MESSAGES.SERVICE_UNAVAILABLE);
    }
  }
  throw new Error(ERROR_MESSAGES.SERVICE_UNAVAILABLE);
}

async function configForApiType(apiType) {
  const config = {};

  switch (apiType) {
    case API_TYPES.MARKIT_DIGITAL_API:
      //await getMarkitDigitalApiToken(false);
      //console.log('get token from auth api', JSON.stringify(token));
      if (!config.headers) {
        config.headers = {};
      }
      //   config.headers[
      //     'Authorization'
      //   ] = `${token.token_type} ${token.access_token}`;
      //   config.withCredentials = true;
      return config;

    default:
      console.error('Unknown API type');
      return null;
  }
}

export function getUrl(service, apiType) {
  const baseUrl =
    BASE_URLS[apiType][window.MD.ENV ? window.MD.ENV : 'localhost'];
  if (!baseUrl) {
    return service;
  }
  return `${baseUrl}/${service}`;
}

export async function sendGetRequest(
  service,
  apiType = API_TYPES.MARKIT_DIGITAL_API
) {
  if (!hasValue(service)) {
    throw new Error(ERROR_MESSAGES.SERVICE_UNAVAILABLE);
  }

  const url = getUrl(service, apiType);
  const config = await configForApiType(apiType);
  const response = await axios.get(url, config);
  return getValueOrDefault(response, 'data');
}

export async function sendPostRequest(
  service,
  body,
  apiType = API_TYPES.MARKIT_DIGITAL_API
) {
  if (!hasValue(service)) {
    throw new Error(ERROR_MESSAGES.SERVICE_UNAVAILABLE);
  }

  const url = getUrl(service, apiType);
  const config = await configForApiType(apiType);
  const response = await axios.post(url, body, config);
  return getValueOrDefault(response, 'data');
}
